<script setup lang="ts" generic="T extends { lat: number; lng: number }">
import type { IMapMarkerOffset } from "@/components/ui/map/map-spiderfy";
import type { ClassValue } from "clsx";

import { cn } from "@/utils/libs/tailwind-utils";

import MapMarker from "@/components/ui/map/map-marker.vue";

interface IProps {
  marker: T;
  containerClass?: ClassValue;
  backgroundColor?: string;
  spiderfyOffset?: IMapMarkerOffset;
  visible?: boolean;
}

interface IEmits {
  (e: "click", payload: T): void;
}

const props = defineProps<IProps>();
defineEmits<IEmits>();
</script>

<template>
  <MapMarker
    :marker="props.marker"
    :offset="props.spiderfyOffset"
    :visible="props.visible"
    @click="$emit('click', $event)"
  >
    <div
      class="p-[10px] bg-brand text-white text-base rounded-[16px] shadow-lg border border-brand"
      :class="cn(props.containerClass, 'whitespace-nowrap overflow-hidden text-ellipsis !max-w-[180px] !py-[6px]')"
      :style="{
        background: props.backgroundColor,
        borderColor: props.backgroundColor,
      }"
    >
      <slot
        :marker="props.marker"
        name="label"
      />
    </div>
    <div class="relative">
      <div
        class="map-marker-tip w-0 h-0 -mt-px border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-brand mx-auto"
        :style="{
          borderTopColor: props.backgroundColor,
        }"
      />
    </div>
  </MapMarker>
</template>
